enum SceneKeys
{
	Preloader = 'preloader',
	Game = 'game'
}

export default SceneKeys
